import React, { createRef, useRef, useState } from "react";
import styled from "styled-components"
import { EColor } from "../../styleConstants";
import { breakPoint, rem } from "../styleUtils";
import Button from "./button";
import TextField from "./textField";

const FormElement = styled.form`
    
`

interface PendingValidation {
    value: string
    name: string
    status: "valid"|"pending"|"invalid"
}

export default function Form ({
    children,
    action,
    method = "POST",
    onSubmit
}: {
    children: string | JSX.Element | JSX.Element[] | (string | JSX.Element)[]
    action?: string
    method?: string
    onSubmit?: (fields: Map<string, PendingValidation>) => void
}) {

    const childrenArray = [].concat(children)
    const initialPendingValidations = new Map<string, PendingValidation>([])

    for (const child of childrenArray) {
        if (child.type === TextField) {
            const reactElement = child as React.ReactElement<any>
            initialPendingValidations.set(reactElement.props.name, {
                value: reactElement.props.defaultValue,
                name: reactElement.props.name,
                status: "pending"
            })
        }
    }

    const formElement = useRef<HTMLFormElement>(null);


    const [runValidations, setRunValidations] = useState<number>(0)
    const [pendingValidations, setPendingValidations] = useState<Map<string, PendingValidation>>( initialPendingValidations )
    const [hasPendingValidations, setHasPendingValidations] = useState<boolean>(false)
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

    const submitHandler = (event) => {
        event.preventDefault()
        setHasPendingValidations(true)
        setRunValidations(new Date().getTime())
    }

    const checkPendingValidations = () => {
        let allValid = true
        let allChecked = true

        pendingValidations.forEach((validation) => {
            if (validation.status === "pending") {
                allChecked = false
            }
            if (validation.status !== "valid") {
                allValid = false
                return
            }
        })

        const recaptchaEl = formElement.current.querySelector('#recaptcha-value');
        if (recaptchaEl) {
            const recaptchaInputEl = recaptchaEl as HTMLInputElement;
            if (recaptchaInputEl.value.length == 0) {
                allValid = false;
            }
        }

        if (allValid && formElement.current) { 
            //All inputs has been validated
            //We can continue with submission
            allValid = true
            
            setIsSubmitting(true)
            if (onSubmit) {
                onSubmit(pendingValidations)
            } else {
                formElement.current.submit()
            }
        } else {
            allValid = false
        }

        if (allChecked) {
            setHasPendingValidations(false)
        }
    }

    if (hasPendingValidations) {
        checkPendingValidations()
    }

    return (
        <FormElement ref={formElement} onSubmit={submitHandler} action={action} method={method}>
            {childrenArray.map((child, index) => {
                if (child.type === TextField) {
                    const reactElement = child as React.ReactElement<any>
                    
                    return (
                        <div key={index}>
                            {
                                React.cloneElement(reactElement, {
                                    runValidation: runValidations,
                                    onChangeCallback: (value, name) => {
                                        pendingValidations.set(name,  {
                                            value: value,
                                            name: name,
                                            status: "pending",
                                        })
                                        setPendingValidations(new Map(pendingValidations))
                                    },
                                    onValidateCallback: (status, name: string, value: string) => {
                                        pendingValidations.set(name,  {
                                            value: value,
                                            name: name,
                                            status: status,
                                        })
                                        setPendingValidations(new Map(pendingValidations))
                                    }
                                })
                            }
                        </div>
                    )
                    
                } else if (child.type === Button) {
                    const reactElement = child as React.ReactElement<any>
                    if (reactElement.props.submitButton) {
                        return (
                            <div key={index}>
                                {
                                    React.cloneElement(reactElement, {
                                        showSpinner: hasPendingValidations || isSubmitting
                                    })
                                }
                            </div>
                        )
                    } else {
                        return <div key={index}>{child}</div>
                    }
                } else {
                    return <div key={index}>{child}</div>
                }
            })}
        </FormElement>
    )
}